export default __webpack_public_path__ + "images/06187c7ee70f97f3a5dc16bc6d039c25.svg";